import { Component, inject } from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialogRef,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

export interface EditFolderDialogData {
    folderName: string;
}

@Component({
    selector: 'r1-compass-lib-edit-folder-dialog',
    imports: [
        MatFormFieldModule,
        MatInputModule,
        FormsModule,
        MatButtonModule,
        MatDialogTitle,
        MatDialogContent,
        MatDialogActions,
        MatDialogClose,
    ],
    template: `
        <h2 mat-dialog-title id="title">Folder</h2>
        <mat-dialog-content id="form">
            <mat-form-field>
                <mat-label>Folder Name</mat-label>
                <input matInput [(ngModel)]="data.folderName" />
            </mat-form-field>
        </mat-dialog-content>
        <mat-dialog-actions id="buttons">
            <button mat-raised-button (click)="onNoClick()" type="button">Cancel</button>
            <button
                mat-raised-button
                [mat-dialog-close]="data.folderName"
                [disabled]="!data.folderName.trim()"
                cdkFocusInitial
                color="primary"
                type="button">
                Save
            </button>
        </mat-dialog-actions>
    `,
    styles: `
        #title {
            background-color: var(--r1-black);
            color: var(--r1-white);
        }
        #form {
            padding-top: 20px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        #buttons {
            padding: 0px 24px;
            display: flex;
            justify-content: flex-end;
        }
        mat-form-field {
            width: 100%;
        }
    `,
})
export class EditFolderDialogComponent {
    dialogRef = inject<MatDialogRef<EditFolderDialogComponent>>(MatDialogRef);
    data = inject<EditFolderDialogData>(MAT_DIALOG_DATA);

    onNoClick(): void {
        this.dialogRef.close();
    }
}
